import React from 'react'
import { array, func, string } from 'prop-types'
import cx from 'classnames'

const CheckboxList = ({ name, items, values, onChange }) => {
  // const isChecked = (item) => values.includes(item)

  return items?.map((item, index) => (
    <div key={item}>
      <input
        id={`${name}-${index}`}
        type="checkbox"
        name={name}
        value={item}
        onChange={onChange}
      />

      <label htmlFor={`${name}-${index}`}>{item}</label>
    </div>
  ))
}

CheckboxList.propTypes = {
  name: string,
  items: array,
  values: array,
  onChange: func
}

export default CheckboxList
